export default __webpack_public_path__ + "static/media/clockify.8fe9fbce.svg";